import script from "./TabsNav.vue?vue&type=script&setup=true&lang=js"
export * from "./TabsNav.vue?vue&type=script&setup=true&lang=js"

import "./TabsNav.vue?vue&type=style&index=0&id=65e3512a&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65e3512a"]])

export default __exports__